import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "2-state-01-diamond",
  "use": "2-state-01-diamond-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"2-state-01-diamond\">\n  <path d=\"M512 69.479l442.498 442.498-442.498 442.498-442.498-442.498 442.498-442.498z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol